import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import React, { useState } from "react";
import localeText from "../../../../../locale";
import useAskQuestion from "../hooks/useAskQuestion";

const AskModal = ({ visible, setAsFalse, headerText, idProduct, setQuestions }) => {
  const handleClose = () => {
    if (isLoading) return;
    setIsMessageSent(false);
    setAsFalse();
    setText("");
  };
  const { text, setText, isLoading, postAsk, isMessageSent, setIsMessageSent } = useAskQuestion({
    idProduct,
    setAsFalse,
    setQuestions,
  });

  const messageSentTemplate = () => {
    return (
      <div className="flex justify-content-start">
        <Button
          onClick={handleClose}
          className="border-round-lg w-full flex justify-content-between align-items-center font-medium text-sm p-3"
          style={{
            backgroundColor: "#E6FBF3BF",
            color: "#208C56",
            border: "1px solid #08D48B14",
          }}
        >
          <div className="flex align-items-center gap-2">
            <i style={{ color: "#08D48B" }} className="pi pi-verified"></i>
            <span>Sua mensagem foi registrada.</span>
          </div>
          <div className="flex align-items-center gap-2">
            <span>Voltar</span> <span style={{ color: "#CEF7E8" }}>|</span>
            <div className="flex align-items-center">
              <i
                style={{ color: "#19191C", fontSize: "0.5rem" }}
                className="pi pi-times font-semibold"
              ></i>
            </div>
          </div>
        </Button>
      </div>
    );
  };

  return (
    <Dialog
      header={headerText}
      visible={visible}
      className=""
      onHide={handleClose}
      draggable={false}
      style={{ maxWidth: "535px" }}
    >
      <div className="flex flex-column gap-4">
        <div style={{ color: "#000000" }} className="text-sm font-normal">
          {localeText("questionExplanation")}
        </div>
        <div>
          <label className="text-sm font-semibold" style={{ color: "#000000" }} htmlFor="textarea">
            {localeText("yourQuestion")}
          </label>
          <InputTextarea
            value={text}
            className="w-full mt-1"
            style={{ resize: "none" }}
            onChange={(e) => setText(e.target.value)}
            id="textarea"
            rows={5}
            cols={30}
            disabled={isMessageSent}
          />
        </div>
        {isMessageSent ? (
          messageSentTemplate()
        ) : (
          <div className="flex justify-content-start mt-2 gap-2">
            <Button
              onClick={postAsk}
              label={localeText("ask")}
              loading={isLoading}
              className="border-round-lg border-none"
              style={{
                flex: "1 1 0",
                maxWidth: "163px",
                backgroundColor: "#28AB69",
                color: "#D9F7EC",
              }}
            />

            <Button
              onClick={handleClose}
              severity="secondary"
              label={localeText("cancel")}
              className="border-round-lg border-none"
              style={{
                flex: "1 1 0",
                maxWidth: "163px",
                backgroundColor: "#D9F7EC",
                color: "#28AB69",
              }}
            />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default AskModal;
